module.exports = __webpack_public_path__ + "assets/gongju.388cc83f.svg";